import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { restartCurrentAction, stopGenerate } from 'redux/toolbar';
import Loader from './Loader';
import Icon from './Icon';

const ToolbarWriting = () => {
  /* Helpers */
  const dispatch = useDispatch();

  return (
    <Wrapper>
      <Loading>
        <Icon source='lizzy' name='lizzy-logo-grey-small' />
        <Text>Lizzy is writing</Text>
        <Loader />
      </Loading>
      <Actions>
        {/* TODO: Make button from Button component  */}
        <button size='small' onClick={() => dispatch(stopGenerate())}>Stop ESC</button>
        <button size='small' onClick={() => dispatch(restartCurrentAction())}>Try again R</button>
      </Actions>
    </Wrapper>
  );
}

export default ToolbarWriting;

const Wrapper = styled.div`
  padding: 0 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Loading = styled.div`
  display: flex;
  align-items: center;
`;

const Text = styled.span`
  color: var(--lizzy-black-35);
  font-size: 13px;
  padding: 0 8px;
`;

const Actions = styled.div`
  button {
    all: unset;
    color: var(--lizzy-black-35);
    border: 1px solid var(--lizzy-black-35);
    border-radius: 5px;
    font-size: 12px;
    cursor: pointer;
    padding: 3px 8px;
    line-height: 14px;

    &:not(:last-child) {
      margin-right: 6px;
    }
  }
`;